<template>
  <el-form :inline="true" :model="form" label-width="65px">
    <el-form-item :label="params.label">
      <el-select
        v-model="value"
        :placeholder="params.placeholder"
        size="small"
        :class="params.className"
      >
        <el-option
          :label="item.value"
          :value="item.key"
          v-for="item in options"
          :key="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'v-select',
  props: {
    params: {
      type: Object
    },
    rowData: {
      type: Object
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      value: this.rowData
        ? this.rowData[this.params.key]
          ? this.rowData[this.params.key]
          : this.params.value
        : this.params.value,
      options: []
    }
  },
  computed: {
    ...mapGetters(['brands']),
    replyTypeList() {
      return this.$store.getters.replyTypeList.map((val) => {
        return {
          key: val.id,
          value: val.title
        }
      })
    }
  },
  mounted() {
    // 需转化成 key value 形式
    if (this.params && this.params.options) {
      // 自定义 js写死的
      this.options = this.params.options
    } else if (this[this.params.optionskey]) {
      // 接口获取的 通过 store 保存 mapGetters 返回
      this.options = JSON.parse(JSON.stringify(this[this.params.optionskey]))
      this.$emit('update:form', { brandId: this.value })
    }
  },
  methods: {
    reset() {
      if (this.params.dValue) {
        this.value = this.params.dValue
      } else {
        this.value = undefined
      }
    },
    getValue() {
      if (this.value || this.value === 0) {
        return {
          [this.params.key]: this.value
        }
      }
      return undefined
    }
  },
  watch: {
    value(nv, ov) {
      console.log(nv)
      const cp = JSON.parse(JSON.stringify(this.params))
      cp.value = nv
      const form = {}
      form[this.params.key] = nv
      this.$emit('update:form', form)
    }
  }
}
</script>
